export default {
  INCORRECT_ENTITIES: 'INCORRECT_ENTITIES',
  RESET_VALIDATION_STATUS: 'RESET_VALIDATION_STATUS'
}



/** WEBPACK FOOTER **
 ** ./src/constants/ErrorsConstants.js
 **/